// extracted by mini-css-extract-plugin
export var container = "index-module--container--2DZmC";
export var bookingLabel = "index-module--bookingLabel--2LYmk";